import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSimOwnerDetailsStyles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_4 = _tokens$spacing.SPACING_4,
    SPACING_16 = _tokens$spacing.SPACING_16;
  return StyleSheet.create({
    content: {
      marginTop: SPACING_4
    },
    input: {
      marginBottom: SPACING_16
    },
    title: {
      marginBottom: SPACING_16
    }
  });
};